import { type Device } from '@/models/device/Device';
import { createApiResource } from '../api';
import { HttpError, getJwt } from '../common';

const BASE_URL = import.meta.env.VITE_API_URL;

export const deviceApi = {...createApiResource<Device, string>('device/devices'),    
    toggleEnabled: async (id: string): Promise<void> => {
        const response = await fetch(`${BASE_URL}/device/devices/${id}/enabled`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${getJwt()}`
            }
        });

        const contentType = response.headers.get('content-type') ?? '';
        const data = contentType.includes('json') ? await response.json().catch(() => null) : await response.text().catch(() => '');

        if (!response.ok) throw new HttpError(response.status, data);       
    }};